function roundVector(vec){
    vec[0]=Math.round(vec[0]*10)/10;
    vec[1]=Math.round(vec[1]*10)/10;
    return vec;
}

function makeVector(pos_start,pos_end,length){
    if(typeof pos_end=="undefined"){
        pos_end=[0,0];
    }
    var vec=[pos_end[0]-pos_start[0],pos_end[1]-pos_start[1]];
    if(length){
        vec=scaleVector(vec,length);
    }
    return vec;
}
function lengthVectorPow(vec){
    return (vec[0]*vec[0]+vec[1]*vec[1]);
}
function lengthVector(vec){
    return Math.sqrt(lengthVectorPow(vec));
}
function scaleVector(vec,length,vec_length){
    if(!vec_length){
        vec_length=lengthVector(vec);
    }
    return [vec[0]/vec_length*length,vec[1]/vec_length*length];
}
function addVector(vec1,vec2){
    return [vec1[0]+vec2[0],vec1[1]+vec2[1]];
}
function minusVector(vec1,vec2){
    return [vec1[0]-vec2[0],vec1[1]-vec2[1]];
}
function addVectorToPoint(pos,vec){
    return addVector(pos,vec);
}
function isEqualVectors(a,b){
    if(a[0]==b[0] && a[1]==b[1]){
        return true;
    }
    return false;
}
function angleClockFromVector(vec){
    if(vec[0]==0){
        if(vec[1]<0){
            return 0;
        }
        return 180;
    }
    else if(vec[1]==0){
        if(vec[0]>0){
            return 90;
        }
        return 270;
    }
    else{
        var deg=0,plus=0;
        if(vec[0]>0){


            if(vec[1]>0){
                plus=90;
                deg=Math.atan(vec[1]/vec[0]);
            }
            else{
                deg=Math.atan(vec[0]/(-vec[1]));
            }
        }
        else{
            if(vec[1]<0){
                deg=Math.atan((-vec[1])/(-vec[0]));
                plus=270;
            }
            else{
                deg=Math.atan((-vec[0])/vec[1]);
                plus=180;
            }
        }
        deg=Math.round(deg/Math.PI*1800)/10+plus;
        return deg;

    }
}
function makeVecPath(pathArr,vec){
    var arr_len=pathArr.length;
    if(arr_len==0){
        pathArr.push(vec);
    }
    else{
        var lastEl=pathArr[arr_len-1];
        pathArr.push(addVector(lastEl,vec));
    }
}
function isBallCollision(pos1,radius1,pos2,radius2){
    var radius=radius1+radius2;
    if(Math.abs(pos1[0]-pos2[0])>radius &&
    Math.abs(pos1[1]-pos2[1])>radius){
        return 0;
    }
    var vec=minusVector(pos1,pos2);
    if(lengthVector(vec)<radius){
        return 1;
    }
    return 0;
}
function rotateVectorByPoint(v,angle,by_point){
    angle=angle*Math.PI/180;
    var vp=[
      (v[0]-by_point[0])*Math.cos(angle)-(v[1]-by_point[1])*Math.sin(angle)+by_point[0],
      (v[0]-by_point[0])*Math.sin(angle)-(v[1]-by_point[1])*Math.cos(angle)+by_point[1]
    ];
    return vp;
}



function translatePoints(arr,dir){
    var pp=copyArray(arr),i,i_max=pp.length;
    for(i=0;i<i_max;i+=2){
        pp[i]+=dir[0];
        pp[i+1]+=dir[1];
    }
    return pp;
}
function rotatePoints(arr,angle_pi){
    var pp=copyArray(arr);
    var x,y,cosA=Math.cos(angle_pi),sinA=Math.sin(angle_pi);
    var i,i_max=pp.length;
    for(i=0;i<i_max;i+=2){
        x=pp[i];
        y=pp[i+1];
        pp[i]=x*cosA-y*sinA;
        pp[i+1]=x*sinA+y*cosA;
    }
    return pp;
}
function addPointsBetween(arr,pos1,pos2,count){
    if(!count){
        count=1;
    }
    var dir=makeVector(pos1,pos2);
    var i;
    for(i=1;i<=count;i++){
        arr.push(pos1[0]+dir[0]/(count+1)*i);
        arr.push(pos1[1]+dir[1]/(count+1)*i);
    }
}

function addCheckPoints(cornersArr,count){//prepareCheckArr
    if(!count){
        count=2;
    }
    var pp=copyArray(cornersArr);
    addPointsBetween(pp,[pp[0],pp[1]],[pp[2],pp[3]],count);//add count points between corners
    addPointsBetween(pp,[pp[2],pp[3]],[pp[4],pp[5]],count);
    addPointsBetween(pp,[pp[4],pp[5]],[pp[6],pp[7]],count);
    addPointsBetween(pp,[pp[6],pp[7]],[pp[0],pp[1]],count);
    addPointsBetween(pp,[pp[0],pp[1]],[pp[4],pp[5]],count);
    addPointsBetween(pp,[pp[2],pp[3]],[pp[6],pp[7]],count);
    return pp;
}
function makeCorners(size_full){
    var size=[size_full[0]/2,size_full[1]/2];
    return [
        -size[0],-size[1],
        size[0],-size[1],
        size[0],size[1],
        -size[0],size[1]
    ];//corners
}
function isInRegion(pos_click,pos,size,anchor){
    var startX = pos[0]-size[0]*anchor[0], startY = pos[1]-size[1]*anchor[1];
    var endX = startX+size[0],endY= startY+size[1];
    if(pos_click[0]>=startX && pos_click[0]<=endX && pos_click[1]>=startY && pos_click[1]<=endY) {
      return 1;
    }
    return 0;
    
}
